<script>
// import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { todoMethods, todoComputed } from "@/state/helpers";
import { tableData } from "../dataAdvancedtable";
import { validateNumber, validateText, validateCurp } from "@/helpers/utils.js";
import axios from "axios";
import moment from "moment";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "NuevaMTarjeta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      checked: true,
      checked1: true,
      label: "",
      active: 1,
      dataOn: "On",
      dataOff: "Off",
      tarjetas: [],
      estatus: ["Activo", "Desactivo"],

      // ************************************** Link
      tableData: tableData,
      title: "Nuevo Registro",
      items: [
        {
          text: "Mujeres",
          href: "/Mujeres",
        },
        {
          text: "Nuevo Registro",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      whatsapp: "No",
      hijos: "No",
      municipios: [],
      ocupaciones: [],
      mensaje: "",
      showMessage: false,
      curpExists: false,
      objeto: {
        id_tarjeta: "",
        curp: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        id_tipo: 5,
        fecha_nacimiento: "",
        colonia: "",
        celular: "",
        estatus: "Activo",
        fecha_creacion: "",
        fecha_modificacion: "",
        // Nuevos campos
        email: "",
        edad: "",
        calle: "",
        numero_exterior: "",
        id_municipio: "",
        escolaridad_terminada: "",
        estado_civil: "",
        ocupacion: "",
        ingreso_mensual: "",
        cantidad_hijos: "",
        cantidad_dependientes_economicos: "",
        edad_primer_hijo: "",
        episodio_violencia: "No",
        tipo_violencia: "",
        lugar_violencia: "",
        redes_sociales: [],
        whatsapp: "",
        //nocupaciones_list: [],
      },
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    getStyles: function () {
      if (this.curpExists) {
        return { color: "red" };
      } else {
        return { color: "green" };
      }
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },

    municipioList() {
      if (this.municipios.length > 0) {
        const data = this.municipios.map((x) => {
          return { text: x.nombre_municipio, value: x.id_municipio };
        });
        // sort data by alphabetical order
        return data.sort((a, b) => {
          return a.text.localeCompare(b.text);
        });
      } else return [];
    },

    // ocupacionesList() {
    //   if(this.ocupaciones.length > 0) {
    //     const data = this.ocupaciones.map(x => {
    //       return { text: x.descripcion, value: x.id_ocupacion, }
    //     });
    //     // sort data by alphabetical order
    //     return data.sort((a, b) => {
    //       return a.text.localeCompare(b.text);
    //     })
    //   } else return [];
    // },
    coloniasList() {
      if (this.objeto.id_municipio != "") {
        // give me the list of colonias that are inside the selected municipio
        const colonias = this.municipios.filter((x) => {
          return x.id_municipio == this.objeto.id_municipio;
        });
        const coloniasTextValue = colonias[0].colonias.map((x) => {
          return { text: x.colonia, value: x.colonia };
        });
        // sort data by alphabetical order
        return coloniasTextValue.sort((a, b) => {
          return a.text.localeCompare(b.text);
        });
      } else return [];
    },

    // computed that checks if fecha_nacimiento is more than 18 years old
    isAdult() {
      if (this.objeto.fecha_nacimiento) {
        let fecha = this.objeto.fecha_nacimiento;
        const years = moment().diff(fecha, "years");
        return years >= 18;
      } else {
        return true;
      }
    },
    isAdultEdad() {
      if (this.objeto.edad) return this.objeto.edad >= 18;
      else return true;
    },
  },

  mounted() {
    // axios.get("http://ec2-18-237-53-89.us-west-2.compute.amazonaws.com:3010/app/tarjetas?request_type=lite").then((res) => {
    //   const { response = "", data = [] } = res.data;
    //   if (response === true) {
    //     const array = [];
    //     data.forEach((t) => {
    //       array.push(t.folio);
    //     });
    //     this.tarjetas = array;
    //   }
    // });

    this.getMunicipios();

    // this.getOcupaciones();

    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.
    this.update();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    this.objeto.fecha_creacion = moment().format("YYYY-MM-DD");
    this.objeto.fecha_modificacion = moment().format("YYYY-MM-DD");
  },

  methods: {
    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    // get municipios
    getMunicipios() {
      axios.get("/municipios_colonias").then((res) => {
        const { response = "", data = [] } = res.data;
        if (response === true) {
          this.municipios = data;
        }
      });
    },

    //get ocupaciones
    // getOcupaciones(){
    //   axios.get("/ocupaciones").then((res)=>{
    //     const {response = "", data = []} = res.data;
    //     if (response === true){
    //       this.ocupaciones = data;
    //     }
    //   })
    // },

    // method that validate keypress only numbers
    validateNumber(event, value, max) {
      if (value) {
        if (value.toString().length + 1 > max) {
          event.preventDefault();
        } else {
          validateNumber(event);
        }
      } else {
        validateNumber(event);
      }
      
      axios
        .get(
          `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/tarjetas_filter?folio=${this.objeto.id_tarjeta}`
        )
        .then((res) => {
          const { response = "", data = [] } = res.data;
          if (response === true) {
            const array = [];
            data.forEach((t) => {
              array.push({ id_tarjeta: t.id_tarjeta, folio: t.folio });
            });
            this.tarjetas = array;
          }
        })
        .catch((error) => {
          // Muestra el error en la consola
          console.error("Error en la solicitud:", error);

          // Si el error tiene respuesta, muestra el código de estado y el mensaje
          if (error.response) {
            console.log("Código de estado:", error.response.status);
            console.log("Datos de error:", error.response.data);
          } else if (error.request) {
            // Si no hubo respuesta del servidor
            console.log("No se recibió respuesta del servidor:", error.request);
          } else {
            // Otro tipo de error
            console.log("Error desconocido:", error.message);
          }
        });
    },
    validateText(event, value, max) {
      if (value) {
        if (value.toString().length + 1 > max) {
          event.preventDefault();
        } else validateText(event);
      } else {
        validateText(event);
      }
    },
    validateLength(event, value, max) {
      if (value) {
        if (value.length + 1 > max) {
          event.preventDefault();
        }
      }
    },
    validateCurp(event, value, max) {
      if (value) {
        if (value.length + 1 > max) {
          event.preventDefault();
        } else validateCurp(event);
      } else {
        validateCurp(event);
      }
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    checkForm(e) {
      var form = document.getElementById("form-new-woman");
      if (form.checkValidity() === true) {
        if (!this.isAdult || !this.isAdultEdad) {
          this.$swal(
            "Alerta",
            "La edad y fecha de nacimiento deben ser mayor de 18 años",
            "warning"
          );
        } else {
          this.handleSubmit();
        }
      }
      form.classList.add("was-validated");
      e.preventDefault();
      e.stopPropagation();
    },

    checkCurp() {
      const curp = this.objeto.curp.toUpperCase();
      this.showMessage = false;
      console.log(curp);
      if (curp === "") {
        this.mensaje = "Agrega una CURP";
        this.showMessage = true;
        this.curpExists = true;
      } else {
        axios
          .get(`/mujeres?curp=${curp}`)
          .then((res) => {
            console.log(res);
            const { response = "" } = res.data;
            if (response === true) {
              this.mensaje = "Ya Existe CURP";
              this.showMessage = true;
              this.curpExists = true;
            }
          })
          .catch((err) => {
            console.log(err.response);
            if (err?.response?.data?.response === false) {
              this.mensaje = "No existe CURP";
              this.showMessage = true;
              this.curpExists = false;
            } else {
              this.mensaje = "Hubo un error";
              this.showMessage = true;
              this.curpExists = true;
            }
          });
      }
    },

    handleSubmit() {
      this.objeto.curp = this.objeto.curp.toUpperCase();
      const payload = JSON.stringify(this.objeto);
      console.log(payload);
      console.log(this.objeto);
      axios
        .post("/usuarios", payload)
        .then((res) => {
          const { response = "" } = res.data;
          if (response === true) {
            this.$swal("Registro", "Resgitro creado correctamente", "success");
            this.$router.push("/Mujeres");
          } else {
            this.$swal("Alerta", "No se pudo crear", "warning");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.$swal("Error", "Ocurrio un error", "error");
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-row class="mb-6">
      <v-col md="12">
        <v-card>
          <b-form id="form-new-woman" novalidate class="needs-validation">
            <div class="card-body">
              <v-col md="12">
                <v-row>
                  <v-card-text>
                    <h4 class="card-title mb-4">Información de la Mujer</h4>
                  </v-card-text>
                  <v-col md="4">
                    <b
                      ><label class="form-check-label"
                        >Folio de tarjeta</label
                      ></b
                    >
                    <div class="mb-4">
                      <b-form-input
                        list="tarjetas_list"
                        v-model="objeto.id_tarjeta"
                        pattern=".{11,}"
                        @keypress="validateNumber($event, objeto.id_tarjeta, 20)"
                      ></b-form-input>
                      <datalist id="tarjetas_list">
                        <option
                          v-for="tarjeta in tarjetas"
                          :key="tarjeta.id_tarjeta"
                          :value="tarjeta.folio"
                        >
                          {{ tarjeta.folio }}
                        </option>
                      </datalist>
                    </div>
                  </v-col>
                  <v-col md="3">
                    <b><label class="form-check-label">CURP</label> </b>
                    <div class="mb-4">
                      <b-form-input
                        class="text-uppercase"
                        v-model="objeto.curp"
                        id="input-curp"
                        pattern=".{18}"
                        placeholder="XXAX010101XXXXXX1"
                        @keypress="validateCurp($event, objeto.curp, 18)"
                        required
                      ></b-form-input>
                    </div>
                  </v-col>
                  <v-col md="1" style="display: grid">
                    <v-btn
                      color="primary"
                      type="button"
                      @click="checkCurp()"
                      style="margin-top: 17px"
                    >
                      Checar
                    </v-btn>
                    <span v-if="showMessage" :style="getStyles">{{
                      mensaje
                    }}</span>
                  </v-col>
                  <v-col md="4">
                    <b><label class="form-check-label">Email</label> </b>
                    <div class="mb-4">
                      <b-form-input
                        v-model="objeto.email"
                        id="input-email"
                        type="email"
                        placeholder="ejemplo@gmail.com"
                      ></b-form-input>
                    </div>
                  </v-col>
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información personal</h4>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label"> Nombre</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.nombre"
                          type="text"
                          id="input-md"
                          placeholder="Nombre"
                          @keypress="validateText($event, objeto.nombre, 40)"
                          trim
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b>
                        <label class="form-check-label">
                          Apellido Paterno</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.apellido_paterno"
                          id="input-md"
                          placeholder="Apellido Paterno"
                          @keypress="
                            validateText($event, objeto.apellido_paterno, 40)
                          "
                          trim
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b>
                        <label class="form-check-label">
                          Apellido Materno</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.apellido_materno"
                          id="input-md"
                          placeholder="Apellido Materno"
                          @keypress="
                            validateText($event, objeto.apellido_materno, 40)
                          "
                          required
                          trim
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label">
                          Fecha de Nacimiento</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_nacimiento"
                          id="fecha_nacimiento"
                          :class="{ 'is-invalid-date': !isAdult }"
                          type="date"
                          placeholder="Fecha de Nacimiento"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="2">
                      <b><label class="form-check-label">Edad</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.edad"
                          id="input-edad"
                          :class="{ 'is-invalid-date': !isAdultEdad }"
                          @keypress="validateNumber($event, objeto.edad, 2)"
                          placeholder="Coloque su edad"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Calle</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.calle"
                          id="input-calle"
                          placeholder="Ej. Av. Insurgentes"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b
                        ><label class="form-check-label">Nu. Exterior</label>
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.numero_exterior"
                          id="input-num-exterior"
                          @keypress="
                            validateNumber($event, objeto.numero_exterior, 5)
                          "
                          placeholder="Num. Exterior"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b><label class="form-check-label">Municipio</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.id_municipio"
                          required
                          :options="municipioList"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.id_municipio">
                      <b><label class="form-check-label">Colonia</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.colonia"
                          required
                          :options="coloniasList"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label"
                          >Teléfono Celular</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.celular"
                          placeholder="Celular"
                          min="10"
                          pattern=".{10}"
                          @keypress="validateNumber($event, objeto.celular, 10)"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- ----- INFORMACION PROFESIONAL ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información profesional</h4>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label">Escolaridad</label>
                      </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          id="input-estadocivil"
                          v-model="objeto.escolaridad_terminada"
                          required
                          :options="[
                            { text: 'Ninguna', value: 'Ninguna' },
                            { text: 'Primaria', value: 'Primaria' },
                            { text: 'Secundaria', value: 'Secundaria' },
                            { text: 'Preparatoria', value: 'Preparatoria' },
                            { text: 'Técnico', value: 'Técnico' },
                            { text: 'Profesional', value: 'Profesional' },
                            { text: 'Maestría', value: 'Maestría' },
                            { text: 'Doctorado', value: 'Doctorado' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b
                        ><label class="form-check-label">Estado civil</label>
                      </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          id="input-estadocivil"
                          v-model="objeto.estado_civil"
                          required
                          :options="[
                            { text: 'Soltera', value: 'Soltera' },
                            { text: 'Casada', value: 'Casada' },
                            { text: 'Unión libre', value: 'Unión libre' },
                            { text: 'Divorciada', value: 'Divorciada' },
                            { text: 'Viuda', value: 'Viuda' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b><label class="form-check-label">Ocupación</label> </b>
                      <div class="mb-4">
                        <Multiselect
                          multiple
                          v-model="objeto.ocupacion"
                          required
                          :options="[
                            'Empleada domestica',
                            'Empleada en Empresa Privada o A.C',
                            'Empresaria',
                            'Gobierno',
                            'Hogar',
                            'Maquiladora',
                            'Negocio propio',
                            'Otro',
                            'Pensionada',
                          ]"
                        ></Multiselect>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label"
                          >Ingresos mensuales</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.ingreso_mensual"
                          required
                          :options="[
                            { text: 'Sin ingresos', value: 'Sin ingresos' },
                            { text: 'Entre $1 y $2,500', value: '1 - 2500' },
                            {
                              text: 'Entre $2,500 y $4,000',
                              value: '2500 - 4000',
                            },
                            {
                              text: 'Entre $4,000 y $6,000',
                              value: '4000 - 6000',
                            },
                            {
                              text: 'Entre $6,000 y $8,000',
                              value: '6000 - 8000',
                            },
                            { text: '$8,000 o más', value: '+8000' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b
                        ><label class="form-check-label">Tiene hijos</label>
                      </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="hijos"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="2" v-if="hijos == 'Si'">
                      <b
                        ><label class="form-check-label"
                          >Número de hijas/hijos</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.cantidad_hijos"
                          id="input-md"
                          :required="hijos == 'Si'"
                          @keypress="
                            validateNumber($event, objeto.cantidad_hijos, 2)
                          "
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="hijos == 'Si'">
                      <b
                        ><label class="form-check-label"
                          >A qué edad se tuvo su primer hija/hijo</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.edad_primer_hijo"
                          :required="hijos == 'Si'"
                          :options="[
                            { text: 'Entre 10 y 14 años', value: '10 - 14' },
                            { text: 'Entre 15 y 19 años', value: '15 - 19' },
                            { text: 'Entre 20 y 24 años', value: '20 - 24' },
                            { text: 'Entre 25 o más', value: '+25' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label"
                          >Número de dependientes económicos</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.cantidad_dependientes_economicos"
                          required
                          @keypress="
                            validateNumber(
                              $event,
                              objeto.cantidad_dependientes_economicos,
                              2
                            )
                          "
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- ----- INFORMACION SOBRE VIOLENCIA ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">
                        Información sobre caso de violencia
                      </h4>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label"
                          >Ha vivido un episodio de violencia</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="objeto.episodio_violencia"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.episodio_violencia == 'Si'">
                      <b
                        ><label class="form-check-label"
                          >Cuál tipo de violencia</label
                        >
                      </b>
                      <div class="mb-4">
                        <Multiselect
                          multiple
                          v-model="objeto.tipo_violencia"
                          :required="objeto.episodio_violencia == 'Si'"
                          :options="[
                            'Física',
                            'Psicológica',
                            'Económica',
                            'Patrimonial',
                            'Obstétrica',
                            'Sexual',
                          ]"
                        ></Multiselect>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.episodio_violencia == 'Si'">
                      <b
                        ><label class="form-check-label">En qué lugar</label>
                      </b>
                      <div class="mb-4">
                        <Multiselect
                          multiple
                          v-model="objeto.lugar_violencia"
                          :required="objeto.episodio_violencia == 'Si'"
                          :options="[
                            'Familia',
                            'Trabajo',
                            'Escuela',
                            'Transporte',
                            'En la calle',
                            'En hospital',
                          ]"
                        ></Multiselect>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- ----- INFORMACION DE REDES SOCIALES ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información de redes sociales</h4>
                    </v-col>
                    <v-col md="3">
                      <b-form-group label="Cuenta con redes sociales:">
                        <b-form-checkbox-group
                          id="checkbox-group-2"
                          v-model="objeto.redes_sociales"
                          name="flavour-2"
                        >
                          <b-form-checkbox value="Facebook"
                            >Facebook</b-form-checkbox
                          >
                          <b-form-checkbox value="Instagram"
                            >Instagram</b-form-checkbox
                          >
                          <b-form-checkbox value="TikTok"
                            >TikTok</b-form-checkbox
                          >
                          <b-form-checkbox value="Otra">Otra..</b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </v-col>
                    <v-col md="3">
                      <b
                        ><label class="form-check-label"
                          >Cuenta con WhatsApp</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="whatsapp"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="whatsapp == 'Si'">
                      <b
                        ><label class="form-check-label"
                          >Número de WhatsApp</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.whatsapp"
                          placeholder="Celular de WhatsApp"
                          min="10"
                          pattern=".{10}"
                          @keypress="
                            validateNumber($event, objeto.whatsapp, 10)
                          "
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- ----- INFORMACION DE CONTROL ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información de control</h4>
                    </v-col>
                    <v-col md="4">
                      <b><label class="form-check-label">Estado</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.estatus"
                          size="lg"
                          :options="estatus"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b>
                        <label class="form-check-label">
                          Fecha de creación</label
                        >
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_creacion"
                          id="fecha_creacion"
                          type="date"
                          placeholder="Fecha de creación"
                          disabled
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b
                        ><label class="form-check-label">
                          Última actualización
                        </label>
                      </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_modificacion"
                          id="fecha_modificacion"
                          type="date"
                          placeholder="Última actualización"
                          disabled
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row>
                  <v-col md="12">
                    <!-- <input class="btn btn-primary boton-submit" type="submit" value="Guardar"> -->
                    <v-btn
                      color="primary"
                      type="button"
                      @click="checkForm($event)"
                    >
                      Guardar
                    </v-btn>
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <router-link to="/Mujeres">
                      <v-btn
                        color="error"
                        type="button"
                        id="inputGroupFileAddon03"
                      >
                        Cancelar
                      </v-btn>
                    </router-link>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </b-form>
        </v-card>
      </v-col>
    </v-row>
  </Layout>
</template>